import React from 'react';
import PropTypes from 'prop-types';
import './DashboardCard.css';

function DashboardCard({ 
  title, 
  count, 
  description, 
  backgroundColor = '#EE8F3B', 
  icon: Icon,
  onShowAll 
}) {
  return (
    <div className="dashboard-card" style={{ backgroundColor }}>
      <div className="dashboard-card__content">
        <div className="dashboard-card__info">
          <span className="dashboard-card__title">{title}</span>
          <div className="dashboard-card__stats">
            <span className="dashboard-card__count">{count}</span>
            <span className="dashboard-card__description">{description}</span>
          </div>
          <button className="dashboard-card__button" onClick={onShowAll}>
            Pokaż wszystkie
          </button>
        </div>
      </div>
      {Icon && (
        <div className="dashboard-card__icon-wrapper">
          <Icon className="dashboard-card__icon" />
        </div>
      )}
    </div>
  );
}

DashboardCard.propTypes = {
  title: PropTypes.string.isRequired,
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  description: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string,
  icon: PropTypes.elementType,
  onShowAll: PropTypes.func,
};

DashboardCard.defaultProps = {
  backgroundColor: '#EE8F3B',
  onShowAll: () => {},
};

export default DashboardCard;

